import React, { useContext, useState } from 'react'
import valPer from '../Tools/VerificarPermisos';
import { ContextGloball } from '../Context/ContextGlobal';
import ReporteRetrasos from '../Reportes/ReporteRetrasos';
import PrincipalPersoxSuc from '../Reportes/PrincipalPersoxSuc';
import ColaboradoresPrueba from './ColaboradoresPrueba';
import EvaluacionesCuestionarios from './EvaluacionesCuestionarios';
import DirectorioColaborador from './DirectorioColaborador';
import CumpleaniosColaborador from './CumpleaniosColaborador';

function MenuPrincipalRH() {
    const { setTitulo } = useContext(ContextGloball);
    const [subVentana, setSubVentana] = useState(0);
    const validarVentana = (item) => {
        var cls = subVentana === item ? "itemMenuOk w-100" : "itemMenu w-100";
        return cls;
    }
    function mostrarSubventana(){
        if (subVentana == 1) {
            return (<ReporteRetrasos />)
        } else if (subVentana == 2) {
            return (<PrincipalPersoxSuc />)
        } else if(subVentana == 3){
            return (<ColaboradoresPrueba/>)
        } else if(subVentana == 4){
            return (<EvaluacionesCuestionarios />)
        } else  if(subVentana == 5){
            return (<DirectorioColaborador/>)
        } else if(subVentana == 6){
            return ( <CumpleaniosColaborador/>)
        }
    }
    return (
        <>
            {subVentana == 0 && <div className='container-fluid py-2'>
                <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-1'>
                    {valPer.validarPermiso('10') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(1)}`}
                                onClick={() => { setSubVentana(1); setTitulo('Reportes Retrasos'); }}>
                                <i className="fa-solid fa-calendar-days"></i><span className=""> Retrasos Personal</span></a>
                        </div>}
                    {valPer.validarPermiso('12') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(2)}`}
                                onClick={() => { setSubVentana(2); setTitulo('Personal x Sucursal') }}>
                                <i className="fa-solid fa-people-group"></i><span className=""> Personal x Suc</span></a>
                        </div>}
                    {valPer.validarPermiso('3') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(3)}`}
                                onClick={() => { setSubVentana(3); setTitulo('Personal a Prueba') }}>
                                <i className="fa-solid fa-person-circle-question"></i><span className=""> Personal a Prueba</span></a>
                        </div>}
                    {valPer.validarPermiso('60') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(5)}`}
                                onClick={() => { setSubVentana(5); setTitulo('Directorio Colaboradores') }}>
                                <i className="fa-solid fa-users"></i><span className=""> Directorio</span></a>
                        </div>}

                    {valPer.validarPermiso('71') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(6)}`}
                                onClick={() => { setSubVentana(6); setTitulo('Cumpleaños de Colaboradores') }}>
                                <i className="fa-solid fa-cake-candles"></i><span className=""> Cumpleaños de Colaboradores</span></a>
                        </div>}
                </div>
            </div>}
            {mostrarSubventana()}
            {subVentana !== 0 && <button className='btn text-danger btn-flotante' 
                id='btnSalirMenuRRHH'
                onClick={() => { setTitulo('RRHH'); setSubVentana(0) }}>
                <i className="fa-solid fa-circle-xmark fa-2xl"></i></button>}
        </>
    )
}

export default MenuPrincipalRH